import { render } from "./movieTabBar.vue?vue&type=template&id=055d13c6&scoped=true"
import script from "./movieTabBar.vue?vue&type=script&lang=js"
export * from "./movieTabBar.vue?vue&type=script&lang=js"

import "./movieTabBar.vue?vue&type=style&index=0&id=055d13c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055d13c6"]])

export default __exports__